import { render, staticRenderFns } from "./GuideGenreSettingDialog.vue?vue&type=template&id=00b8cf9e&scoped=true&"
import script from "./GuideGenreSettingDialog.vue?vue&type=script&lang=ts&"
export * from "./GuideGenreSettingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./GuideGenreSettingDialog.vue?vue&type=style&index=0&id=00b8cf9e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8cf9e",
  null
  
)

export default component.exports